import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { post } from "../../../service/api";
import { ListColumns } from "../enum/list-columns";
import { IFetchListsResponseDto } from "../interface/dto/lists.dto";
import { ISelectedFilters } from "../interface/selected-filters";

interface IFetchListsPayload extends ISelectedFilters {
    limit: number;
    offset: number;
    sortField: ListColumns;
    sortDirection: "asc" | "desc";
}

export const getList = (
    payload: IFetchListsPayload,
    tokens: ITokenPair,
): Observable<IFetchListsResponseDto> =>
    post<IFetchListsResponseDto, IFetchListsPayload>(
        "/lists/search",
        payload,
        undefined,
        tokens,
    );
